import gql from 'graphql-tag'

export const GET_USERS_BY_TYPE = gql`
    query ($orgId:uuid!, $userTypeId: uuid!){
        Users: Users(where: {organizationId: {_eq: $orgId}, userTypeId: {_eq: $userTypeId}}){
            id
            name
            mobile
            email
        }
    }`

export const GET_USER_BY_MOBILE = gql`
    query($id:uuid!,$mobile:String!){
        Users(where:{id:{_neq:$id}, mobile:{_eq:$mobile}}){
            id
        }
    }`
